function usePushStateForClientRoutes() {
    registerClickHandler();

    window.addEventListener('popstate', () => {
        activateCurrentHash();
    });

    if (window.location.hash) {
        activateCurrentHash();
    }
}

function registerClickHandler() {
    $(`a[data-router="client-route"], button[data-router="client-route"]`).on('click', (event) => {
        showClientRoute($(event.currentTarget).attr('href'));

        broadcastRouteChange($(event.currentTarget).attr('href').substring(1));
    });
}

function activateCurrentHash() {
    let hash = window.location.hash.substring(2);

    const parameters = hash.split('/');

    hash = parameters.shift();

    broadcastRouteChange(hash, parameters);
}

function broadcastRouteChange(hash, parameters) {
    Bus.$emit('clientRouteChanged', hash, parameters);
}

function currentClientRoute() {
    if (!window.location.hash) {
        return null;
    }

    var hash = window.location.hash.substring(2);

    var parameters = hash.split('/');

    hash = parameters.shift();

    return {
        hash: hash,
        parameters: parameters,
    };
}

function clearClientRoute() {
    history.pushState(null, null, '#');
}

function showClientRoute(href) {
    history.pushState(null, null, href);
}

function getCursorFromHash(identity) {
    const route = currentClientRoute();
    if (route && route.hash === identity && route.parameters.length === 1) {
        return route.parameters[0];
    }
}

function getCursorFromURL(url) {
    try {
        return new URL(url).searchParams.get('cursor');
    } catch (e) {
        return null;
    }
}

function setCursorHash(identity, cursor) {
    showClientRoute(cursor ? `#/${identity}/${cursor}` : '#');
}

export {
    usePushStateForClientRoutes,
    registerClickHandler,
    activateCurrentHash,
    broadcastRouteChange,
    currentClientRoute,
    clearClientRoute,
    showClientRoute,
    getCursorFromHash,
    getCursorFromURL,
    setCursorHash,
};
